function checkResolution(query) {
    return checkMedia(query.replace(';',','))
}

function checkMedia(query) {
    let isVisible = false,
        breakPoints = query.split(',');

    $.each(breakPoints, function(key, breakPoint) {
        if (!isVisible) {
            isVisible = $('.c-var__item.' + breakPoint + '-is-visible').is(':visible');
        }
    });

    return isVisible;
}

function setCountdown($element, time, format) {
    $element.countdown(time, function (event) {
        var totalHours = event.offset.totalDays * 24 + event.offset.hours,
            daysString = 'deň';

        if (totalHours >= 120) {
            daysString = 'dní';
        }
        else if (totalHours >= 48) {
            daysString = 'dni';
        }

        var hoursString = $element.data('hours'),
            minutesString = $element.data('minutes'),
            secondsString = $element.data('seconds');

        if (typeof format == 'undefined') {
            format = `
                <div>%D<span>${daysString}</span></div>
                <div class="is-separator">:</div>
                <div>%H<span>${hoursString}</span></div>
                <div class="is-separator">:</div>
                <div>%M<span>${minutesString}</span></div>
                <div class="is-separator">:</div>
                <div>%S<span>${secondsString}</span></div>
            `;
        }

        $(this).html(event.strftime(format));
    })
}

Listing.customCallbacks.afterFetch = function () {
    $(".js-countdown").each(function () {
        setCountdown($(this), $(this).attr("data-time"));
    });
};

$(function() {
    $('.l-base').on('click', '.pager__item .c-link', function() {
        $(this).parents('.listing').slideHere();
    });

    setTimeout(function () {
        bLazy.revalidate();
    }, 250);

    $( ".products__quantity, .cart__products__item--quantity" ).on( "spin", function( event, ui ) {
        var input = $("input", this),
            max = input.attr('max');

        if (ui.value <= max) {
            return true;
        }

        var message = $('.out_of_stock_message').html().replace(":productStock", max);

        Eshop.alert(message, {type: 'danger'});
    });

    $('.js-add-to-wishlist').on('click', function(event) {
        var $button = $(this),
            url = $button.data('href'),
            productId = $button.attr('data-product-id');

        event.preventDefault();

        $.post(url, { product_id: productId }, function (data) {
            Eshop.alert(data.message, { type: data.status ? 'success' : 'error' });

            if (data.status) {
                $button.addClass('is-active');
            }
        }, "json");
    });

    $(".js-countdown").each(function () {
        setCountdown($(this), $(this).attr("data-time"));
    });

    $(".js-recommend-by-mail-form").validate({
        submitHandler: function(form) {
            Form.ajaxPost(form, function(data) {
                $("#send-email .c-msg")
                    .removeClass("c-msg--success c-msg--error hidden no_margin")
                    .text((typeof data.msg.format !== "undefined") ? data.msg.format : data.msg)

                if (data.status) {
                    $("#send-email .c-msg")
                        .addClass("c-msg--success no_margin")
                        .slideDown();

                    $("#send-email form").hide();
                } else {
                    $("#send-email .c-msg")
                        .addClass("c-msg--error")
                        .slideDown();
                }
            }, "json");
        }
    });

    tippy('.js-tippy-ribbon', {
        arrow: true,
        trigger: 'mouseenter focus',
        theme: 'demro',
        interactive: true
    });

    $('.modal').on('show.bs.modal', function () {
        setTimeout(() => {
            freezeScroll();
        }, 0);
    });

    $('.modal').on('hidden.bs.modal', function () {
        unfreezeScroll();
    });

    document.querySelectorAll('a[href*="opencookiebot"]').forEach(function(link) {
        link.addEventListener('click', function(event) {
            event.preventDefault();

            Cookiebot.renew();
        });
    });
});

// Ak swiper zastavi tak ze je na pol pixela, toto opravi ten polovicny pixel
function fixSwiperHalfPixel(swiperElement) {
    var currentTranslate = swiperElement.getTranslate();
    swiperElement.setTranslate(Math.round(currentTranslate));
}

function fixSwiperMultipleIds(swiperContainer) {
    var duplicatedSlides = $(swiperContainer).find('.swiper-slide.swiper-slide-duplicate');

    $(duplicatedSlides).each(function(){
        var elementsWithId = $(this).find('*[id]'),
            randomPrefix = makeid(8);

        $(elementsWithId).each(function(){
            if (!$(this).attr('id').match("^rndprfx")) {
                $(this).attr('id', 'rndprfx' + '_' + randomPrefix + '_' + $(this).attr('id'));
            }
        });
    });
}

function makeid(length = 5) {
    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz_-";
    for (var i = 0; i < length; i++)
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    return text;
}

tippy('.js-tippy-demro', {
    theme: 'demro',
    arrow: true,
    distance: 12
});

document.addEventListener("DOMContentLoaded", function () {
    const badge = document.querySelector("#js-info-badge");

    function toggleBadgeVisibility() {
        if (window.innerWidth < 600) {
            if (window.scrollY > 20) {
                badge.classList.add("is-hidden");
            } else {
                badge.classList.remove("is-hidden");
            }
        }
    }

    window.addEventListener("scroll", toggleBadgeVisibility);
});
